import invariant from 'invariant';
import querystring from 'query-string';
import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';

export default function getDetailsByPartNumber(params) {
    let { baseUrl, brandId, country, partNumber, options, uberToken, clientId, clientSecret } = params;

    invariant(baseUrl, 'baseUrl is a required param of getDetailsByPartNumber()');
    invariant(brandId, 'brandId is a required param of getDetailsByPartNumber()');
    invariant(country, 'country is a required param of getDetailsByPartNumber()');
    invariant(partNumber, 'partNumber is a required param of getDetailsByPartNumber()');
    invariant(clientId, 'clientId is a required param of getDetailsByPartNumber()');

    const localisedBrand = `${brandId}_${country.toLowerCase()}`;
    const optionalQuery = options ? `?${querystring.stringify(options)}` : '';

    const concatUrl = `${baseUrl}search/resources/store/${localisedBrand}/productview/${partNumber}${optionalQuery}`;
    return labelRequest(authenticatedRequest(new Request(concatUrl), uberToken, clientId, clientSecret), 'getDetailsByPartNumber');
}
